import React from "react";

// Renders **bold** (plum strong) and *italic* (plum em) inline markers.
export default function renderRich(text) {
  if (!text) return null;
  return String(text)
    .split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g)
    .map((part, i) => {
      if (part.startsWith("**") && part.endsWith("**") && part.length > 4)
        return (
          <strong key={i} className="text-plum">
            {part.slice(2, -2)}
          </strong>
        );
      if (part.startsWith("*") && part.endsWith("*") && part.length > 2)
        return (
          <em key={i} className="text-plum font-medium">
            {part.slice(1, -1)}
          </em>
        );
      return part;
    });
}
